import React, { memo, useCallback, useRef, useState } from "react";
import { Menu, MenuItem, Stack } from "@mui/material";
import { CustomListSubheader, ExtraSmallButton } from "../../components/custom";

const replaySpeeds = [5, 2, 1, 0.5, 0.2]

const PlaySpeedMenu: React.FC<{ speed: number, setSpeed: React.Dispatch<React.SetStateAction<number>>}> = ({ speed, setSpeed }) => {
    const anchorRef = useRef<HTMLButtonElement>(null);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl)

    const handleClose = useCallback(() => {
        setAnchorEl(null)
    }, [])

    const handleButtonClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }, [])

    return (
        <>
            <ExtraSmallButton
                sx={{ width: '32px', backgroundColor: theme => theme.palette.background.default }}
                ref={anchorRef}
                data-event={'Replay Speed Menu Opened'}
                onClick={handleButtonClick}
                >
                {speed}x
            </ExtraSmallButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transitionDuration={0}
            >
                <CustomListSubheader>REPLAY SPEED</CustomListSubheader>
                {
                    replaySpeeds.map((s) => (
                        <MenuItem
                            sx={{width: '210px'}}
                            selected={s === speed}
                            key={`${s}x`}
                            onClick={() => {
                                setSpeed(s);
                                handleClose()
                            }}
                        >
                            <Stack width='100%' direction="row" sx={{justifyContent: 'space-between'}}>
                                <span>{s}x</span><span>{s > 1 ? s : 1} upd per {s > 1 ? 1 : Math.floor(1/s)} sec</span>
                            </Stack>
                        </MenuItem>
                    ))
                }
            </Menu>
        </>
    )
}

export default memo(PlaySpeedMenu)